module.exports = __webpack_public_path__ + "img/kg.6c79fb44.svg";